import { render, staticRenderFns } from "./TableHeaderAndRows.vue?vue&type=template&id=2eb64989"
import script from "./TableHeaderAndRows.vue?vue&type=script&lang=ts"
export * from "./TableHeaderAndRows.vue?vue&type=script&lang=ts"
import style0 from "./TableHeaderAndRows.vue?vue&type=style&index=0&id=2eb64989&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports